import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import API from '../lib/api';

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const logout = useCallback(() => {
    API.post('/auth/logout').catch(() => {});
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
  }, []);
  const refreshUser = useCallback(async () => {
    try {
      const { data } = await API.get('/auth/me');
      const { csrf_token, ...current } = data;
      if (csrf_token) API.defaults.headers.common['X-CSRF-Token'] = csrf_token;
      setUser(previous => JSON.stringify(previous) === JSON.stringify(current) ? previous : current);
      localStorage.setItem('user', JSON.stringify(current));
    } catch (e) {
      if ([401, 403].includes(e.response?.status)) logout();
    } finally { setLoading(false); }
  }, [logout]);
  useEffect(() => {
    refreshUser();
    const interval = setInterval(refreshUser, 15000);
    const storage = e => { if (e.key === 'token') refreshUser(); };
    window.addEventListener('focus', refreshUser);
    window.addEventListener('storage', storage);
    window.addEventListener('session-revoked', logout);
    return () => {
      clearInterval(interval);
      window.removeEventListener('focus', refreshUser);
      window.removeEventListener('storage', storage);
      window.removeEventListener('session-revoked', logout);
    };
  }, [refreshUser, logout]);
  const login = useCallback(async (email, password) => {
    const res = await API.post('/auth/login', { email, password });
    API.defaults.headers.common['X-CSRF-Token'] = res.data.csrf_token;
    localStorage.removeItem('token');
    localStorage.setItem('user', JSON.stringify(res.data.user));
    setUser(res.data.user);
    return res.data;
  }, []);
  return <AuthContext.Provider value={{ user, loading, login, logout, refreshUser }}>{children}</AuthContext.Provider>;
};